export default __webpack_public_path__ + "static/media/button__thumbs-up.ac83f65e.svg";